import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './translationEN.json';
import translationDE from './translationDE.json';
import translationFR from './translationFR.json';
import translationNL from './translationNL.json';
import translationES from './translationES.json';
import translationIT from './translationIT.json';
import translationJA from './translationJA.json';
import translationKO from './translationKO.json';
import translationPT from './translationPT.json';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: translationEN
        },
        de: {
            translation: translationDE
        },
        fr: {
            translation: translationFR
        },
        nl: {
            translation: translationNL
        },
        es: {
            translation: translationES
        },
        it: {
            translation: translationIT
        },
        ja: {
            translation: translationJA
        },
        ko: {
            translation: translationKO
        },
        pt: {
            translation: translationPT
        }
    },
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    }
});
export default i18n;
